import { logger } from '@/lib/logger';
import { supabase } from '@/lib/supabase';

export type MembershipResult = 'pro' | 'regular' | 'none';

export interface GetMembershipResponse {
  membership: MembershipResult;
}

export async function getMembership(): Promise<GetMembershipResponse | null> {
  try {
    const { data, error } = await supabase.functions.invoke<GetMembershipResponse>('get-membership', {
      method: 'POST',
    });

    if (error) {
      // This will tell us if it's FunctionsHttpError, FunctionsRelayError, etc.
      const errorType = error.name || error.constructor.name;
      const message = error.message || 'No message';
      
      logger.error('get-membership error', { 
        errorType, 
        message,
        // This helps catch if it's a CORS/Network issue (TypeError: Failed to fetch)
        isNetworkError: error instanceof TypeError 
      });

      return null;
    }

    if (data?.membership !== undefined) {
      return { membership: data.membership };
    }

    logger.warn('get-membership unexpected response', { data });
    return null;
  } catch (err) {
    logger.error('get-membership exception', { err });
    return null;
  }
}
